import { formatMoney } from '@debbie/common/dist/format-money.js';
import { clearAmounts, useMoneyCalculator, } from '@debbie/cortex/dist/moneyCalculator/index.js';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const MoneyCalculator = () => {
    const amounts = useMoneyCalculator();
    return amounts.length > 0 ? React.createElement(Panel, { amounts: amounts }) : null;
};
const Panel = ({ amounts }) => {
    const lang = useSelector((s) => s.lang);
    useEffect(() => {
        const clearOnEscape = (e) => {
            if (e.key === 'Escape') {
                clearAmounts();
            }
        };
        document.addEventListener('keydown', clearOnEscape);
        return () => {
            document.removeEventListener('keydown', clearOnEscape);
        };
    }, []);
    const locale = lang.is.currently;
    const sum = amounts.reduce((total, amount) => total + amount, 0);
    return (React.createElement(StyledCalculator, null,
        React.createElement("small", { style: { color: THEME.TEXT_MUTED } },
            lang.financials.moneyCalculator.sum,
            ' '),
        React.createElement("span", { style: { fontSize: '1.6em', fontWeight: 'bold' } }, formatMoney(locale, sum)),
        React.createElement("div", { style: { marginTop: '5px', fontSize: '0.8em', textAlign: 'right' } },
            React.createElement("span", { style: { color: THEME.TEXT_MUTED } },
                lang.financials.moneyCalculator.average,
                ' '),
            React.createElement("strong", null,
                formatMoney(locale, sum / amounts.length),
                " "),
            React.createElement("span", { style: { color: THEME.TEXT_MUTED } },
                lang.financials.moneyCalculator.count,
                ' '),
            React.createElement("strong", null, amounts.length))));
};
export default MoneyCalculator;
const StyledCalculator = styled.div `
  position: fixed;
  bottom: 265px;
  right: ${THEME.GRID_SPACING}px;
  padding: ${THEME.GRID_SPACING}px;
  background-color: ${THEME.COLOR_SECONDARY};
  box-shadow: 0 20px 70px -30px black;
`;
//# sourceMappingURL=MoneyCalculator.js.map